import numeral from 'numeral'
import { useTranslation } from 'react-i18next'
import { createElement, Fragment } from 'react'

export interface IEnumColor {
  background?: string
  color?: string
}

export type TranslateFunction = (text: string, params?: Record<string, unknown>) => string

export type EnumType = 'UserStatus'

export function useTranslator() {
  const { t } = useTranslation()

  /**
   * Get translation
   * @param text
   * @param params
   */
  function __(text: string, params: Record<string, unknown> = {}): string {
    return t(text, params)
  }

  /**
   * Get number format
   * @param value
   * @param type
   */
  function __n(value: unknown, currency: string = '') {
    if (value === null || value === undefined) return '--'

    const num = Number(value)

    if (isNaN(num)) return '--'

    // Format phần nguyên
    const integerPart = numeral(Math.trunc(num)).format('0,0')

    // Kiểm tra phần thập phân
    const decimalStr = num.toString().split('.')[1]

    if (!decimalStr || /^0+$/.test(decimalStr)) {
      if (currency) {
        return createElement(
          Fragment,
          null,
          integerPart,
          createElement('span', { className: 'font-medium underline underline-offset-4 ml-1' }, currency)
        )
      }

      return integerPart
    }

    // Cắt phần thập phân về tối đa 6 chữ số, không thêm 0
    const trimmedDecimal = decimalStr.slice(0, 4)

    if (currency) {
      return createElement(
        Fragment,
        null,
        `${integerPart}.${trimmedDecimal}`,
        createElement('span', { className: 'font-medium underline underline-offset-4 ml-1' }, currency)
      )
    }

    return `${integerPart}.${trimmedDecimal}`
  }

  /**
   * Get currency format
   * @param value
   * @param currency
   */
  function __c(value: unknown) {
    if (value == null) return __('N/A')

    return `${__n(value)}`
  }

  /**
   * Get compact currency format (2 decimal places,)
   * @param value
   */
  function __cc(value: unknown) {
    if (value === null || value === undefined) return '--'
    const num = Number(value)

    if (isNaN(num)) return '--'

    return numeral(num).format('0,0.[00]')
  }

  function __ec(value: any, enumType: EnumType): IEnumColor {
    // @ts-ignore
    const key = ec[enumType]

    if (!key) {
      console.log('cannot find enum key for ', enumType)

      return {}
    }

    // @ts-ignore
    return key[value]
  }

  return { __, __n, __c, __ec, __cc }
}
